import { FlexProps } from '@procore/core-react/dist/_typedoc/Flex/Flex.types.json';
import * as React from 'react';
export default {
  FlexProps,
  React
};